import { Reducer } from "redux";

export interface DealerPriceState {
  IsDealerPrice?: boolean;
  MessageTop?: string;
  MessageTopTitle?: string;
  MessageBottom?: string;
}

type DealerPriceType = DealerPriceState | null | undefined;
const defaults: DealerPriceType = null;

export const reducer: Reducer<DealerPriceType> = (state: DealerPriceType = defaults): DealerPriceType => {
  return state;
};

export const actions = {};
